const config = {
  // imageBaseURL: 'http://localhost:8080'    
  imageBaseURL: 'https://docmaster.spaplc.com'            // for image links
};

export default config;